const t = "date", e = {
  date: t
};
export {
  t as date,
  e as default
};
